import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line, RiGalleryUploadLine } from 'react-icons/ri';


interface slider{
  id:number,
  image:string,
}

const Gallery = () => {
    const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
    const [sliderdata, setSliderdata] = useState<slider[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventsList, setEventsList] = useState<any[]>([]);
    const [selectedEventFilter, setSelectedEventFilter] = useState<string>('ALL');

    useEffect(() => {
      axios.get('https://rmbbackend.rmbjaipur.com/auth/events')
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data?.events || res.data?.data || []);
          setEventsList(list);
        })
        .catch(err => console.error("Error fetching events in Gallery:", err));
    }, []);

    // Open modal
    const openModal = (postId: string) => {
      setSelectedPostId(postId);
      setIsModalOpen(true);
    };
  
    // Function to close modal and clear the post ID
    const closeModal = () => {
      setSelectedPostId(null);
      setIsModalOpen(false);
    };
  
    const deletePost = async (id: any) => {
      if (!id) {
        alert('Invalid ID. Cannot delete.');
        return;
      }
      const confirmation = window.confirm('Are you sure you want to delete this image?');
      if(!confirmation){
        return;
      }
    
      try {
        await axios.delete(`https://rmbbackend.rmbjaipur.com/auth/gallery/${id}`);
        alert('Image deleted successfully!');
        window.location.reload();
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('Failed to delete the image. Please try again later.');
      }
    };
    
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<slider[]>(
            "https://rmbbackend.rmbjaipur.com/auth/gallery"
          );
          setSliderdata(response.data);
        } catch (error) {
          console.error("Gallery Not Found:", error);
        }
      };
  
      fetchData();
    }, []);

  const filteredSliderData = sliderdata.filter((item: any) => {
    if (selectedEventFilter !== 'ALL' && (item.event_id || '').toString() !== selectedEventFilter) {
      return false;
    }
    return true;
  });

  return (
    <div className='p-4 space-y-4'>
      <div className='w-full'>
        <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 rounded-xl shadow-sm border">
          <div className='flex justify-center w-[130px] cursor-pointer h-[42px] px-3 py-2 bg-[#FDBC12] text-[#0A2451] font-bold items-center rounded-lg gap-2 shadow hover:bg-amber-400 transition' onClick={() => openModal('')}>
            <BsPlusCircleFill/> <h6>Add New</h6>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-slate-700 uppercase">📅 Filter Gallery by Event:</span>
            <select
              value={selectedEventFilter}
              onChange={(e) => setSelectedEventFilter(e.target.value)}
              className="py-2 px-3 border border-slate-300 rounded-lg text-xs font-bold text-[#0A2451] bg-white outline-none focus:ring-2 focus:ring-[#FDBC12]"
            >
              <option value="ALL">All Events Gallery</option>
              {eventsList.map((evt) => (
                <option key={evt.id} value={evt.id.toString()}>
                  {evt.heading} ({evt.start_date})
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-4">
          {filteredSliderData.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {filteredSliderData.map((item: any) => (
                <div key={item.id} className='bg-white rounded-lg p-2 drop-shadow-md border border-slate-100 flex flex-col justify-between'>
                  <img
                    className="h-40 object-cover flex justify-center items-center w-full max-w-full rounded-lg mb-2"
                    src={
                      item.image
                        ? item.image.startsWith("http")
                          ? item.image
                          : `https://rmbbackend.rmbjaipur.com/${item.image}`
                        : "https://via.placeholder.com/150"
                    }
                    alt={item.image || "Gallery Image"}
                  />

                  {item.event_heading && (
                    <span className="text-[10px] bg-blue-50 text-blue-800 font-bold px-2 py-0.5 rounded border border-blue-200 mb-2 truncate">
                      📌 {item.event_heading}
                    </span>
                  )}
                  
                  <div className='flex justify-between gap-4'> 
                    <div className='flex w-full justify-center cursor-pointer py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2 text-xs font-bold hover:bg-red-50 transition' onClick={() => deletePost(item.id)}>
                      <RiDeleteBin5Line/> <h6>Delete Post</h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white p-8 rounded-xl shadow-sm border text-center text-slate-500 font-bold text-sm">
              No gallery photos found matching the selected event filter.
            </div>
          )}
        </div>
      </div>
      

   {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal  postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
   </div>
  )
}


interface ModalProps {
  postId?: string | null; 
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [eventId, setEventId] = useState<string>('');
  const [existingFileName, setExistingFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [eventsList, setEventsList] = useState<any[]>([]);

  useEffect(() => {
    axios.get('https://rmbbackend.rmbjaipur.com/auth/events')
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : (res.data?.events || res.data?.data || []);
        setEventsList(list);
      })
      .catch(err => console.error("Error fetching events:", err));
  }, []);

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/gallery/${postId}`);
          const data = Array.isArray(response.data) ? response.data[0] : response.data;
          setExistingFileName(data.image || null);
          setEventId(data.event_id || '');
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };

  const handleRemoveFile = (index: number) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const data = new FormData();
    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        data.append('image', file);
      });
    } else if (existingFileName) {
      data.append('image', existingFileName);
    } else {
      setError('Please select at least one image to upload.');
      setIsSubmitting(false);
      return;
    }

    if (eventId) {
      data.append('event_id', eventId);
    }

    try {
      await axios.post('https://rmbbackend.rmbjaipur.com/auth/gallery', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert(`Successfully added ${selectedFiles.length || 1} image(s) to gallery!`);
      onClose();
      window.location.reload();
    } catch (err: any) {
      console.error('Error submitting post:', err);
      const serverMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Unknown error';
      setError(`Failed to submit: ${serverMsg}`);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-[#1E2B45] w-full max-w-xl p-6 rounded-2xl shadow-2xl border border-slate-200 dark:border-[#2A3B5C] relative text-slate-900 dark:text-slate-100">
        <h2 className="text-base font-black text-[#0A2451] dark:text-white border-b border-slate-200 dark:border-[#2A3B5C] pb-3 mb-4 flex items-center justify-between">
          <span>🖼️ {postId ? 'Edit Gallery Image' : 'Add Multiple Images to Gallery'}</span>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 dark:hover:text-white font-bold text-lg">×</button>
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Event Selection */}
          <div>
            <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1">
              Select Event / Category (Optional)
            </label>
            <select
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
              className="w-full p-2.5 border border-slate-300 dark:border-[#2A3B5C] bg-white dark:bg-[#131E32] text-slate-800 dark:text-slate-100 rounded-xl outline-none font-bold text-xs"
            >
              <option value="">-- No Specific Event (General Gallery) --</option>
              {eventsList.map((evt) => (
                <option key={evt.id} value={evt.id.toString()}>
                  {evt.heading} ({evt.start_date})
                </option>
              ))}
            </select>
          </div>

          {/* Multiple File Upload Zone */}
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="block text-xs font-bold text-slate-700 dark:text-slate-300">
                Upload Event Media / Photographs (Multiple Allowed)
              </label>
              {selectedFiles.length > 0 && (
                <span className="bg-[#FDBC12] text-[#0A2451] text-[11px] font-black px-2 py-0.5 rounded-full shadow-sm">
                  📷 {selectedFiles.length} Selected
                </span>
              )}
            </div>

            <div 
              onClick={() => document.getElementById('file-upload-multiple')?.click()}
              className="w-full min-h-[140px] border-2 border-dashed border-slate-300 dark:border-[#2A3B5C] hover:border-[#FDBC12] bg-slate-50 dark:bg-[#131E32] rounded-xl flex flex-col justify-center items-center p-4 cursor-pointer transition-colors"
            >
              <RiGalleryUploadLine size={32} className="text-amber-500 mb-2" />
              <input
                id="file-upload-multiple"
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={handleFileChange}
              />
              <p className="font-bold text-xs text-center text-slate-700 dark:text-slate-200">
                Click or Drag & Drop to Select <span className="text-amber-600 dark:text-amber-400">Multiple Images</span>
              </p>
              <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-1">
                Supports JPG, PNG, WEBP. Select multiple photos simultaneously.
              </p>
            </div>

            {/* Thumbnail Preview Grid */}
            {selectedFiles.length > 0 && (
              <div className="mt-3">
                <div className="text-[11px] font-bold text-slate-600 dark:text-slate-400 mb-1">Selected Image Previews:</div>
                <div className="grid grid-cols-4 sm:grid-cols-6 gap-2 max-h-44 overflow-y-auto p-1.5 bg-slate-100 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800">
                  {selectedFiles.map((file, idx) => (
                    <div key={idx} className="relative group rounded-lg overflow-hidden border border-slate-300 dark:border-slate-700 bg-white h-16 flex items-center justify-center shadow-xs">
                      <img src={URL.createObjectURL(file)} alt={file.name} className="w-full h-full object-cover" />
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleRemoveFile(idx); }}
                        className="absolute top-0.5 right-0.5 bg-red-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px] font-black shadow hover:bg-red-700 transition cursor-pointer"
                        title="Remove photo"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {existingFileName && selectedFiles.length === 0 && (
              <p className="text-xs text-blue-600 dark:text-blue-400 mt-2 font-semibold truncate">
                Existing File: {existingFileName}
              </p>
            )}
          </div>

          {/* Error Message */}
          {error && <p className="text-xs text-red-500 font-bold bg-red-50 dark:bg-red-950/50 p-2 rounded-lg border border-red-200">{error}</p>}

          {/* Actions */}
          <div className="flex justify-end gap-3 pt-3 border-t border-slate-200 dark:border-[#2A3B5C]">
            <button
              type="button"
              className="px-4 py-2 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-bold text-xs rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 transition"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2 bg-[#FDBC12] text-[#0A2451] font-black text-xs rounded-xl shadow hover:bg-amber-400 transition cursor-pointer active:scale-95 disabled:opacity-50"
              disabled={selectedFiles.length === 0 && !existingFileName || isSubmitting}
            >
              {isSubmitting ? 'Uploading...' : postId ? 'Update Image' : `Upload ${selectedFiles.length || 1} Image(s)`}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Gallery;